module.exports = __webpack_public_path__ + "img/img-wrap.c00768ff.svg";